var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgDrill = function SvgDrill(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 73,
    viewBox: "0 0 72 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14787_583)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.5586 13.9048H46.2275V15.2642H48.2227L48.2646 47.5161H53.1455V69.7759H18.8555V15.2642H20.8887V13.9048H27.5391V3.23682H39.5586V13.9048Z",
    stroke: "#BDBDBD",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2955 14.9722H21.8301V20.2007H45.2955V14.9722Z",
    fill: "#C68106",
    stroke: "black",
    strokeWidth: 1.873
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.2981 16.3267H19.793V68.9756H52.22V48.578H47.3401L47.2981 16.3267Z",
    fill: "#F9BA15",
    stroke: "black",
    strokeWidth: 1.86289
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6882 54.0669H41.3926V69.3996H49.6882V54.0669Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4625 22.3081H25.5293V51.7826H41.4625V22.3081Z",
    fill: "#C68106",
    stroke: "black",
    strokeWidth: 0.931447
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5177 40.7656H21.709V58.1516H28.5177V40.7656Z",
    fill: "#C68106",
    stroke: "black",
    strokeWidth: 0.931447
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6327 4.29883H28.4766V66.5361H38.6327V4.29883Z",
    fill: "#F9BA15",
    stroke: "black",
    strokeWidth: 1.86289
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2461 64.069L33.5544 60.3765L29.8633 64.069H37.2461Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8613 54.1094L33.5552 57.8019L37.2456 54.1094H29.8613Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4269 55.3252L34.7344 59.017L38.4269 62.7087V55.3252Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7559 62.7087L32.4491 59.017L28.7573 55.3252L28.7559 62.7087Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2461 52.3268L33.5544 48.6343L29.8633 52.3261L37.2461 52.3268Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8613 42.3672L33.5552 46.0597L37.2456 42.3679L29.8613 42.3672Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4269 43.583L34.7344 47.2748L38.4269 50.9673V43.583Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7559 50.9673L32.4491 47.2748L28.7573 43.583L28.7559 50.9673Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.425 40.467L29.8633 40.4663L38.4264 31.7231V40.4692L38.425 40.467Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.665 30.5002L37.226 30.5009L28.6621 39.2448L28.6635 30.498L28.665 30.5002Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.425 28.7248L29.8633 28.7241L38.4264 19.981V28.727L38.425 28.7248Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.665 18.758L37.226 18.7587L28.6621 27.5019L28.6635 18.7559L28.665 18.758Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.425 16.9829L29.8633 16.9822L38.4264 8.23828V16.985L38.425 16.9829Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.665 7.01629L37.226 7.017L28.6621 15.7602L28.6635 7.01416L28.665 7.01629Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.419 5.25H29.4102V64.8969H30.419V5.25Z",
    fill: "#F9BA15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6905 5.25H36.6816V64.8969H37.6905V5.25Z",
    fill: "#F9BA15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1524 48.1606H46.4023V52.2665H52.1524V48.1606Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14787_583"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    fill: "white",
    transform: "translate(0 0.506348)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDrill);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "drill.86d629bea86487f77940fc4714ee1fb8.svg";